<template>
    <el-drawer title="新增白名单" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="tels" label="手机号:">
                    <el-input v-model="formData.tels" placeholder="多个手机号用英文逗号分隔"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    "lotteryActivityId": "",
    "tels": ""
}
export default {
    data() {
        return {
            drawerShow: false,
            formData: {
                ...defaultFormData
            },
            btnLoading: false,
            rules: {
                tels: [{ required: true, message: "请输入手机号" }],
            },
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(id) {
            this.formData = {
                ...defaultFormData,
                lotteryActivityId: id,
            }
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: "/lottery/activity/white/add",
                        data: {
                            ...this.formData,
                            tels: this.formData.tels.replaceAll('，', ',')
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate', result);
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped></style>